
import { PracticeSession } from '../types';
import { getDB } from '../lib/db';
import { apiClient, isCloud } from '../lib/apiClient';
import { getQuestions, saveQuestion } from './questionService';
import { calculateNextReview } from './reviewService';

export const getSessions = async (): Promise<PracticeSession[]> => {
  if (isCloud) {
    return await apiClient('/sessions');
  } else {
    const db = await getDB();
    const sessions = await db.getAll('sessions');
    return sessions.sort((a, b) => b.date - a.date);
  }
};

export const saveSession = async (s: PracticeSession): Promise<void> => {
  if (isCloud) {
    await apiClient('/sessions', {
        method: 'POST',
        body: JSON.stringify(s)
    });
  } else {
    const db = await getDB();
    await db.put('sessions', s);
  }
  
  // Update question stats & Review Schedule
  const questions = await getQuestions();
  for (const det of s.details) {
      const q = questions.find(x => x.id === det.questionId);
      if (q) {
          // 1. Basic Stats
          if (det.isCorrect) q.correctCount = (q.correctCount || 0) + 1;
          else q.mistakeCount = (q.mistakeCount || 0) + 1;
          
          q.lastPracticedAt = Date.now();
          
          // 2. Spaced Repetition Schedule
          // Only update schedule if we are NOT in a "Browsing" context (implied by saving a session)
          // We assume any practice session counts towards memory curve
          const { stage, nextReview } = calculateNextReview(q.reviewStage || 0, det.isCorrect);
          q.reviewStage = stage;
          q.nextReviewAt = nextReview;

          await saveQuestion(q);
      }
  }
};

export const deleteSession = async (id: string): Promise<void> => {
    if (isCloud) {
       await apiClient(`/sessions/${id}`, { method: 'DELETE' });
    } else {
       const db = await getDB();
       await db.delete('sessions', id);
    }
};
